<div class="insurance-search-container ui-g-12 no-padding">

	@if (allowedSearchGroups() === null)
	{
	<div class="drawer-loading">
		<i class="loading-spinner theme-color fa fa-fw fa-spin fa-spinner">
		</i>
	</div>
	}

	@if (allowedSearchGroups() !== null)
	{
	<div class="search-input-section ui-g-12 no-padding">
		<div class="search-input-row">
			<div class="p-inputgroup">
				<div class="search-input-wrapper">
					<label for="search-input"
						class="visually-hidden">
						Search
					</label>
					<input #searchInput
						id="search-input"
						pInputText
						type="text"
						placeholder="Search..."
						[class.has-clear]="searchTerm()"
						[ngClass]="{'ng-invalid': inputValidationMessage()}"
						[class.ng-dirty]="inputValidationMessage()"
						[ngModel]="searchTerm()"
						(ngModelChange)="searchTerm.set($event)"
						(keyup.enter)="inputValidationMessage() ? null : search()" />
					@if (searchTerm())
					{
					<button type="button"
						class="pi pi-times clear-icon"
						aria-label="Clear search"
						(click)="clearSearch()"
						(keyup.enter)="clearSearch()">
					</button>
					}
				</div>
				<button pButton
					type="button"
					class="p-button-icon"
					icon="pi pi-search"
					[disabled]="loading() || searchTerm().trim() == '' || inputValidationMessage() != ''"
					(click)="search()">
				</button>
			</div>
			<i class="fa fa-info-circle info-icon theme-color"
				[pTooltip]="quickFindTooltip"
				[escape]="false"
				tooltipPosition="left"
				tooltipStyleClass="quick-find-tooltip"
				mobileTooltip
				#tooltipDirective="mobileTooltip"
				(tap)="tooltipDirective.mobileTooltipToggle()"
				(click)="tooltipDirective.preventDefault($event)"
				(keyup.enter)="tooltipDirective.mobileTooltipToggle()">
			</i>
		</div>
		@if (inputValidationMessage())
		{
		<div class="ui-g-12 no-vertical-padding validation-message-container">
			<div class="validation-message theme-color-red">
				{{inputValidationMessage()}}
			</div>
		</div>
		}
	</div>

	<div class="filter-tabs ui-g-12 no-padding">
		@for (option of visibleSearchGroupOptions(); track option.groupKey)
		{
		<button class="filter-chip theme-chip-outlined"
			type="button"
			[class.active]="isFilterActive(option.filterLabel)"
			[attr.aria-pressed]="isFilterActive(option.filterLabel)"
			(click)="toggleFilter(option.filterLabel)">
			<i class="fa fa-check filter-check-icon"
				aria-hidden="true">
			</i>
			{{option.filterLabel}}
		</button>
		}
	</div>

	@if (loading())
	{
	<div class="ui-g-12 no-horizontal-padding
			text-center">
		<i class="loading-spinner theme-color fa fa-fw fa-spin fa-spinner">
		</i>
	</div>
	}

	@if (hasSearched() && !loading())
	{
	@if (initialSearchError())
	{
	<div class="search-error-container">
		<button class="search-error-retry theme-color"
			type="button"
			(click)="search()"
			(keyup.enter)="search()">
			Error Loading. Retry?
		</button>
	</div>
	}
	@if (!initialSearchError())
	{
	<div class="sort-row ui-g-12 no-padding">
		@if (results().length > 0)
		{
		<span class="text-right expand-all-control cursor-pointer theme-color"
			(click)="toggleAllGroups()"
			(keyup.enter)="toggleAllGroups()">
			{{allGroupsExpanded()
			? 'Collapse All'
			: 'Expand All'}}
			<i [ngClass]="allGroupsExpanded()
				? 'fa fa-caret-up'
				: 'fa fa-caret-down'">
			</i>
		</span>
		}
	</div>

	<!-- Results Container (flex column for sections) -->
	<div class="results-container">

		@for (group of groupedDisplayResults();
		track group.groupKey)
		{
		<div class="result-group"
			[class.expanded]="isGroupExpanded(group.groupKey)">

			<!-- Group Header (always visible) -->
			<div class="group-header"
				[class.cursor-pointer]="group.items.length > 0"
				[class.empty-group-header]="group.items.length === 0"
				(click)="group.items.length > 0 && toggleGroup(group.groupKey)"
				(keyup.enter)="group.items.length > 0 && toggleGroup(group.groupKey)">
				<span class="group-expander-container theme-header-background">
					<i class="group-expander fa fa-fw"
						[ngClass]="group.items.length === 0
							? 'fa-minus'
							: isGroupExpanded(group.groupKey)
								? 'fa-chevron-down'
								: 'fa-chevron-right'">
					</i>
				</span>
				<span class="group-label">
					{{group.displayLabel}}
					({{group.items.length}})
				</span>
			</div>

			<!-- Scrollable Group Content -->
			@if (isGroupExpanded(group.groupKey))
			{
			<div class="group-content-scroll-host"
				[style.height.px]="getGroupScrollHeight(group.groupKey)">
				<div #groupContent>

					@for (item of group.displayItems;
					track item.id)
					{
					<div class="search-result-card"
						[class.expanded]="item.isExpandable && isResultExpanded(item.result)"
						[class.selected-element-border]="item.isExpandable && isResultExpanded(item.result)"
						[class.is-expandable]="item.isExpandable"
						(click)="item.isExpandable && toggleResultDetail(item.result, $event)"
						(keyup.enter)="item.isExpandable && toggleResultDetail(item.result, $event)">

						<!-- Card Header -->
						<div class="card-header">
							<button class="card-title theme-color"
								type="button"
								(click)="
									navigateTo(item.result, item.config);
									$event.stopPropagation()"
								(keyup.enter)="
									navigateTo(item.result, item.config);
									$event.stopPropagation()">
								<span [innerHTML]="
									item.highlightedTitle">
								</span>
							</button>
							@if (item.highlightedStatus)
							{
							<span class="status-badge"
								[ngClass]="item.statusColor
									? 'badge-' + item.statusColor
									: ''">
								<span class="badge-text" [innerHTML]="item.highlightedStatus">
								</span>
							</span>
							}
							@if (item.isExpandable)
							{
							<i class="card-expand-icon fa theme-color"
								[ngClass]="isResultExpanded(item.result)
									? 'fa-chevron-up'
									: 'fa-chevron-down'">
							</i>
							}
						</div>

						<!-- Card Body: Primary Fields -->
						<div class="card-body">
							@for (field of item.displayFields;
							track field.key)
							{
							<div class="card-field">
								<div class="field-header">
									@if (group.config.showFieldIcons !== false)
									{
									<i class="field-icon"
										[ngClass]="field.icon">
									</i>
									}
									<span class="field-label">
										{{field.key}}:
									</span>
								</div>
								@if (field.highlightedValues.length <= 1)
									{
									<span
									class="field-value">
									<span
										[innerHTML]="field.highlightedValues[0]">
									</span>
									</span>
									}
									@if (field.highlightedValues.length > 1)
									{
									<ul class="field-value-list">
										@for (value of field.highlightedValues;
										track $index)
										{
										<li>
											<span [innerHTML]="value">
											</span>
										</li>
										}
									</ul>
									}
							</div>
							}
						</div>

						<!-- Detail Expansion -->
						@if (item.isExpandable && isResultExpanded(item.result))
						{
						<div class="card-detail">
							@for (field of item.detailFields;
							track field.key)
							{
							<div class="card-field">
								<div class="field-header">
									<span class="field-label">
										{{field.key}}:
									</span>
								</div>
								@if (field.highlightedValues.length <= 1)
									{
									<span
									class="field-value">
									<span
										[innerHTML]="field.highlightedValues[0]">
									</span>
									</span>
									}
									@if (field.highlightedValues.length > 1)
									{
									<ul class="field-value-list">
										@for (value of field.highlightedValues;
										track $index)
										{
										<li>
											<span [innerHTML]="value">
											</span>
										</li>
										}
									</ul>
									}
							</div>
							}
						</div>
						}
					</div>
					}

					<!-- Load More -->
					@if (group.hasMore || group.loadError)
					{
					<div class="load-more-row">
						@if (group.loadError)
						{
						<button class="search-error-retry theme-color"
							type="button"
							(click)="retryLoadMore(group, groupContent)"
							(keyup.enter)="retryLoadMore(group, groupContent)">
							Error Loading. Retry?
						</button>
						}
						@if (!group.loadError)
						{
						<button
							class="load-more-btn cursor-pointer theme-chip-outlined"
							[disabled]="group.loading"
							(click)="loadMore(group, groupContent)">
							<i class="fa fa-fw"
								[ngClass]="group.loading
									? 'fa-spinner fa-spin'
									: 'fa-plus-circle'">
							</i>
							<span>
								{{group.loading
								? 'Loading...'
								: 'Load More'}}
							</span>
						</button>
						}
					</div>
					}
				</div>
			</div>
			}
		</div>
		}
	</div>
	}
	}
	}

</div>